import ReactMarkdown from 'react-markdown';
import { useLocalizedMarkdownDate } from 'src/hooks/useLocalizedMarkdownDate';
export type ReactMarkdownStyleProps = {
  text: string;
};

export function ReactMarkdownStyle({ text }: ReactMarkdownStyleProps) {
  const textModified = useLocalizedMarkdownDate(text);
  return (
    <>
      {(textModified?.split?.('\\n') || []).map((paragraph, i) => {
        return (
          <ReactMarkdown key={`${paragraph}-${i}`} className="markdown-links">
            {paragraph}
          </ReactMarkdown>
        );
      })}
    </>
  );
}
